import { DrawSchedule } from '@/models/bank-models.model';
import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CacheLoaderService } from './cache-loader.service';
import { FIDService } from '../app/fid.service';
import { BinderService } from './binder.service';

@Injectable({
  providedIn: 'root'
})
export class DrawsService {
  private BASE_URL = environment.landmark_API_URL;
  drawData = signal<DrawSchedule[]>([]);
  selectedDraw = signal<DrawSchedule | null>(null);

  binderService = inject(BinderService);

  filteredSchedules = computed(() => this.drawData().filter(draw => this.getFIDs().includes(draw.FID)));

  constructor(private http: HttpClient,
    private cacheLoader: CacheLoaderService<DrawSchedule>,
    private fidService: FIDService
  ) { }

  getOfficeDraws(fid:number): Observable<DrawSchedule[]> {
    return this.http.get<DrawSchedule[]>(`${this.BASE_URL}/draws/office/${fid}`);
  }

  setSelectedDraw(draw: DrawSchedule | null) {
    console.log('setSelectedDraw', draw);
    this.selectedDraw.set(draw);
  }

  loadDraws(): void {
    this.cacheLoader.loadData('draws', (draws) => {
        this.setDrawData(draws);
    }, 'lendersCacheKey');
}

  setDrawData(data: DrawSchedule[]) {
    this.drawData.set(data);
  }

  getFIDs() {
    return [this.fidService.determineBankFid(this.binderService.currentBinder().Franchises_Binders_SelectedFIDToFranchises.Bank_FID, this.binderService.currentBinder().SelectedFID), 5]
  }
}
